// Dados do VeloClin Backoffice (interno / comercial)

export const BO_CREDENTIALS = {
  email: "alexandreps83@yahoo.com.br",
  password: "121083@Ab",
};

export const PLAN_META = {
  solo: { label: "Solo", price: 149, color: "bg-violet-50 text-violet-700 border-violet-200" },
  basic: { label: "Basic", price: 399, color: "bg-blue-50 text-blue-700 border-blue-200" },
  max: { label: "Max", price: 899, color: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const STATUS_META = {
  ativo: { label: "Ativo", color: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  inadimplente: { label: "Inadimplente", color: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  cancelado: { label: "Cancelado", color: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-400" },
  pausado: { label: "Pausado", color: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const INITIAL_CUSTOMERS = [];

// Cálculo financeiro do assinante: VeloClin recebe assinatura + % das consultas; o restante é repassado
export const customerFinance = (c) => {
  const ticket = Number(c.ticketMedio) || 0;
  const faturamentoConsultas = (Number(c.consultasMes) || 0) * ticket;
  const takePct = Number(c.takeRatePct) || 0;
  const veloclinConsultas = (faturamentoConsultas * takePct) / 100;
  const assinatura = Number(c.mrr) || 0;
  const veloclinTotal = assinatura + veloclinConsultas;
  const repasseMedico = faturamentoConsultas - veloclinConsultas;
  return { ticket, faturamentoConsultas, takePct, veloclinConsultas, assinatura, veloclinTotal, repasseMedico };
};

export const STAGES = [
  { id: "prospeccao", label: "Prospecção", accent: "border-t-slate-400" },
  { id: "contato", label: "Contato Realizado", accent: "border-t-blue-500" },
  { id: "reuniao", label: "Reunião Agendada", accent: "border-t-violet-500" },
  { id: "ganho", label: "Fechamento (Ganho)", accent: "border-t-emerald-500" },
  { id: "perdido", label: "Fechamento (Perdido)", accent: "border-t-rose-400" },
];

export const INITIAL_LEADS = [];

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0 }).format(v || 0);
